import Demographic from './demographic';
import Questions from './questions/';
import Donations from './donations/';
import FB from './fb';
import Email from './email';
import Terms from './tems';
import EmailNotify from './emailNotify';
import Conversation from './conversation';
import Guest from './guest';

const Features = {
  Demographic,
  Questions,
  Donations,
  FB,
  Email,
  Terms,
  EmailNotify,
  Conversation,
  Guest
};

export default Features;
